(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, RECURSO_EDUCATIVO_FORM_ADMIN) {
        var config = RECURSO_EDUCATIVO_FORM_ADMIN();
        var base = "admin/aulaDigital/recursoEducativo";
        var params = {
            parent: "admin/aulaDigital/tema",
            view: 'contentChildren',
            base: base,
            baseUrl: "/{temaid}/recurso-educativo",
            translateBase: "aulaDigital.recursoEducativo.admin.",
            templateList: '<recurso-educativo-list-admin></recurso-educativo-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    template: '<ng-include src="\'app/components/auladigital/admin/aula-digital-breadcrumb.admin.html\'"></ng-include>' +
                    '<div ui-view="contentChildren"></div>'
                }
            },
            resolve: {
                /* @ngInject */
                tema: function ($stateParams, Tema) {
                    // TODO: ¿Optimizar y obtener sólo ID y nombre?
                    return Tema.get({id: $stateParams.temaid}).$promise;
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (RecursoEducativo, $stateParams) {
                    return RecursoEducativo.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();
